"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TravelHotelSearchSortingMethod = exports.TravelPricingStrategy = exports.ManuallyCancelledHotelRefundFailureReason = exports.CancelHotelFailureReason = exports.isTransientBookHotelFailureReason = exports.BookHotelFailureReason = exports.TravelHotelRefundSource = exports.TravelHotelBookingStatus = exports.TravelPaymentMethodType = exports.TravelDeadlineType = exports.DEFAULT_TRAVEL_HOTEL_PAGE_SIZE = exports.TravelHotelType = exports.TravelHotelImageType = exports.TravelHotelSource = void 0;
var TravelHotelSource;
(function (TravelHotelSource) {
    TravelHotelSource["priceline"] = "priceline";
    TravelHotelSource["bookingHoldings"] = "bookingHoldings";
})(TravelHotelSource || (exports.TravelHotelSource = TravelHotelSource = {}));
var TravelHotelImageType;
(function (TravelHotelImageType) {
    TravelHotelImageType["default"] = "DEFAULT";
    TravelHotelImageType["large"] = "LARGE";
    TravelHotelImageType["thumbnail"] = "THUMBNAIL";
})(TravelHotelImageType || (exports.TravelHotelImageType = TravelHotelImageType = {}));
var TravelHotelType;
(function (TravelHotelType) {
    TravelHotelType["hotel"] = "HOTEL";
})(TravelHotelType || (exports.TravelHotelType = TravelHotelType = {}));
// Amenity category codes on historical Priceline-sourced travel_hotel rows (persisted in the amenities jsonb).
var PricelineStayAmenityCategoryCode;
(function (PricelineStayAmenityCategoryCode) {
    PricelineStayAmenityCategoryCode["Accessibility"] = "ACCESSIBILITY";
    PricelineStayAmenityCategoryCode["ActivitiesAndThingsToDo"] = "ACTIVITIES_AND_THINGS_TO_DO";
    PricelineStayAmenityCategoryCode["BusinessFacilities"] = "BUSINESS_FACILITIES";
    PricelineStayAmenityCategoryCode["FitnessActivities"] = "FITNESS_ACTIVITIES";
    PricelineStayAmenityCategoryCode["FoodAndDrinks"] = "FOOD_AND_DRINKS";
    PricelineStayAmenityCategoryCode["General"] = "GENERAL";
    PricelineStayAmenityCategoryCode["HealthServices"] = "HEALTH_SERVICES";
    PricelineStayAmenityCategoryCode["KidFriendly"] = "KID_FRIENDLY";
    PricelineStayAmenityCategoryCode["LanguagesSpoken"] = "LANGUAGES_SPOKEN";
    PricelineStayAmenityCategoryCode["MediaAndTechnology"] = "MEDIA_AND_TECHNOLOGY";
    PricelineStayAmenityCategoryCode["Other"] = "OTHER";
    PricelineStayAmenityCategoryCode["OutdoorRecreation"] = "OUTDOOR_RECREATION";
    PricelineStayAmenityCategoryCode["RoomAmenities"] = "ROOM_AMENITIES";
    PricelineStayAmenityCategoryCode["SanitationProcedures"] = "SANITATION_PROCEDURES";
    PricelineStayAmenityCategoryCode["Security"] = "SECURITY";
    PricelineStayAmenityCategoryCode["ServicesAndConveniences"] = "SERVICES_AND_CONVENIENCES";
    PricelineStayAmenityCategoryCode["Sustainability"] = "SUSTAINABILITY";
    PricelineStayAmenityCategoryCode["SwimmingAndSoaking"] = "SWIMMING_AND_SOAKING";
    PricelineStayAmenityCategoryCode["Transportation"] = "TRANSPORTATION";
})(PricelineStayAmenityCategoryCode || (PricelineStayAmenityCategoryCode = {}));
exports.DEFAULT_TRAVEL_HOTEL_PAGE_SIZE = 10;
var TravelDeadlineType;
(function (TravelDeadlineType) {
    TravelDeadlineType["absolute"] = "absolute";
    TravelDeadlineType["secondsAfterBooking"] = "secondsAfterBooking";
})(TravelDeadlineType || (exports.TravelDeadlineType = TravelDeadlineType = {}));
var TravelPaymentMethodType;
(function (TravelPaymentMethodType) {
    TravelPaymentMethodType["avenCreditCard"] = "AVEN_CREDIT_CARD";
    TravelPaymentMethodType["avenDeposit"] = "AVEN_DEPOSIT";
})(TravelPaymentMethodType || (exports.TravelPaymentMethodType = TravelPaymentMethodType = {}));
/** @TranslateToPython @TranslateToEnum */
var TravelHotelBookingStatus;
(function (TravelHotelBookingStatus) {
    TravelHotelBookingStatus["pending"] = "pending";
    TravelHotelBookingStatus["booked"] = "booked";
    TravelHotelBookingStatus["cancelled"] = "cancelled";
})(TravelHotelBookingStatus || (exports.TravelHotelBookingStatus = TravelHotelBookingStatus = {}));
var TravelHotelRefundSource;
(function (TravelHotelRefundSource) {
    TravelHotelRefundSource["hotelCancellation"] = "hotelCancellation";
    TravelHotelRefundSource["bookingFailure"] = "bookingFailure";
    TravelHotelRefundSource["opsRefundAndMarkHotelCancelled"] = "opsRefundAndMarkHotelCancelled";
    TravelHotelRefundSource["opsRefundCancelledHotel"] = "opsRefundCancelledHotel";
})(TravelHotelRefundSource || (exports.TravelHotelRefundSource = TravelHotelRefundSource = {}));
var BookHotelFailureReason;
(function (BookHotelFailureReason) {
    BookHotelFailureReason["bookingHoldingsApiFailure"] = "BHI_API_FAILURE";
    BookHotelFailureReason["bookingHoldingsProcessing"] = "BHI_PROCESSING";
    BookHotelFailureReason["bookingHoldingsUnknownError"] = "BHI_UNKNOWN_ERROR";
    BookHotelFailureReason["bookingAlreadyCancelled"] = "BOOKING_ALREADY_CANCELLED";
    BookHotelFailureReason["itineraryPreviewNotFound"] = "ITINERARY_PREVIEW_NOT_FOUND";
    BookHotelFailureReason["itineraryPreviewMissingData"] = "ITINERARY_PREVIEW_MISSING_DATA";
    BookHotelFailureReason["notOnAllowlist"] = "NOT_ON_ALLOWLIST";
    BookHotelFailureReason["noPurchasePermission"] = "NO_PURCHASE_PERMISSION";
    BookHotelFailureReason["paymentFailed"] = "PAYMENT_FAILED";
    BookHotelFailureReason["depositInsufficientFunds"] = "DEPOSIT_INSUFFICIENT_FUNDS";
})(BookHotelFailureReason || (exports.BookHotelFailureReason = BookHotelFailureReason = {}));
// Whether a BHI book failure should trigger a BullMQ retry (transient or terminal)
const isTransientBookHotelFailureReason = (reason) => {
    switch (reason) {
        case BookHotelFailureReason.paymentFailed:
        case BookHotelFailureReason.bookingHoldingsProcessing:
            return true;
        default:
            return false;
    }
};
exports.isTransientBookHotelFailureReason = isTransientBookHotelFailureReason;
// bookingHoldings* values map to BHI cancel/confirmCancel failures.
var CancelHotelFailureReason;
(function (CancelHotelFailureReason) {
    CancelHotelFailureReason["hotelNotInBookedStatus"] = "HOTEL_NOT_IN_BOOKED_STATUS";
    CancelHotelFailureReason["cannotGetUnitRate"] = "CANNOT_GET_UNIT_RATE";
    CancelHotelFailureReason["cannotGetHotelDetails"] = "CANNOT_GET_HOTEL_DETAILS";
    CancelHotelFailureReason["bookingHoldingsApiFailure"] = "BOOKING_HOLDINGS_API_FAILURE";
    CancelHotelFailureReason["cancellationAfterCheckIn"] = "CANCELLATION_AFTER_CHECK_IN";
    CancelHotelFailureReason["refundFailed"] = "REFUND_FAILED";
    CancelHotelFailureReason["unknownError"] = "UNKNOWN_ERROR";
})(CancelHotelFailureReason || (exports.CancelHotelFailureReason = CancelHotelFailureReason = {}));
/**
 * Failure reasons specific to the ops-only "the hotel already cancelled this off-platform" path.
 * That flow never calls BHI cancel/confirmCancel, so it can't produce the reasons above that come
 * from those calls; it has its own preconditions instead.
 */
var ManuallyCancelledHotelRefundFailureReason;
(function (ManuallyCancelledHotelRefundFailureReason) {
    ManuallyCancelledHotelRefundFailureReason["hotelNotInBookedStatus"] = "HOTEL_NOT_IN_BOOKED_STATUS";
    /** The bookingHoldingsBookingId the reviewer typed doesn't match the one on the row. */
    ManuallyCancelledHotelRefundFailureReason["bookingHoldingsBookingIdMismatch"] = "BOOKING_HOLDINGS_BOOKING_ID_MISMATCH";
    /** Row has no bookingHoldingsBookingId, so we can't confirm the cancellation with BHI. */
    ManuallyCancelledHotelRefundFailureReason["missingBookingHoldingsBookingId"] = "MISSING_BOOKING_HOLDINGS_BOOKING_ID";
    /** BHI's Booking Detail endpoint is down or errored; we refuse to refund without confirmation. */
    ManuallyCancelledHotelRefundFailureReason["bookingHoldingsApiFailure"] = "BOOKING_HOLDINGS_API_FAILURE";
    /** BHI still shows the booking as live, so the hotel did not actually cancel it. */
    ManuallyCancelledHotelRefundFailureReason["notCancelledAtBookingHoldings"] = "NOT_CANCELLED_AT_BOOKING_HOLDINGS";
    /** Requested refund exceeds what we charged the user. */
    ManuallyCancelledHotelRefundFailureReason["refundExceedsChargeAmount"] = "REFUND_EXCEEDS_CHARGE_AMOUNT";
    /** The refund posted, or the row write, failed. */
    ManuallyCancelledHotelRefundFailureReason["refundFailed"] = "REFUND_FAILED";
    ManuallyCancelledHotelRefundFailureReason["unknownError"] = "UNKNOWN_ERROR";
})(ManuallyCancelledHotelRefundFailureReason || (exports.ManuallyCancelledHotelRefundFailureReason = ManuallyCancelledHotelRefundFailureReason = {}));
var TravelPricingStrategy;
(function (TravelPricingStrategy) {
    /**
     * This is for cardholders who get 10% cashback. We will markup the price by 11.11% to account for the cashback.
     */
    TravelPricingStrategy["markupFor10xPoints"] = "markupFor10xPoints";
    /**
     * This marks up the net rate by 3%, useful for covering Stripe payment processing fees.
     */
    TravelPricingStrategy["markupThreePercent"] = "markupThreePercent";
    /**
     * This passes through the net rate. What Aven pays is what the user sees.
     */
    TravelPricingStrategy["passThroughNetRate"] = "passThroughNetRate";
})(TravelPricingStrategy || (exports.TravelPricingStrategy = TravelPricingStrategy = {}));
var TravelHotelSearchSortingMethod;
(function (TravelHotelSearchSortingMethod) {
    TravelHotelSearchSortingMethod["priceLowToHigh"] = "priceLowToHigh";
    TravelHotelSearchSortingMethod["distanceNearToFar"] = "distanceNearToFar";
})(TravelHotelSearchSortingMethod || (exports.TravelHotelSearchSortingMethod = TravelHotelSearchSortingMethod = {}));
